<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="ctrPublicId" v-model="searchParams.ctrPublicId" :options ="publicCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 10rem"
                                @change="changePublicId" :disabled="disabledCtrPublicId" scrollHeight="20em" :editable="true"/>
                        <label for="ctrPublicId">관할행정</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="corpId" v-model="searchParams.corpId" :options ="custCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"
                                    @change="changeCustSeq" :disabled="isCustUser" scrollHeight="20em" :editable="true"/>
                        <label for="corpId">업체명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="areaTag" v-model="searchParams.areaTag" :options ="cboAreaTags" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem" scrollHeight="20em"/>
                        <label for="areaTag">영역분류</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="gubun" v-model="searchParams.gubun" :options ="cboGubun" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"/>
                        <label for="gubun">구분</label>
                    </div>
                    <div class="p-field-0 p-float-label m-2">
                        <div class="p-inputgroup">
                            <InputText id="calcYm" v-model="searchParams.calcYm" type="text" style="width:8rem" @keydown.enter="btnDialog('CodeHelpDialog', searchParams.calcYm)"/>
                            <label for="calcYm">평가년도</label>
                            <Button icon="pi pi-search" class="p-button-search" @click="btnDialog('CodeHelpDialog', searchParams.calcYm)" />
                        </div>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="calcCnt" type="text" style="width:8rem" v-model="searchParams.calcCnt" disabled/>
                        <label for="calcCnt">평가차수</label>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar inputId="calcFrYmd" v-model="searchParams.calcFrYmd" :showIcon="false" style="width: 10rem" readonly/>
                        <label for="calcFrYmd">평가시작일자</label>
                    </div>
                    <div class="p-field p-float-label m-auto ml-1 mr-1 t-center" style="width: 1rem">
                        <span>~</span>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar inputId="calcToYmd" v-model="searchParams.calcToYmd" :showIcon="false" style="width: 10rem" readonly/>
                        <label for="calcToYmd">평가종료일자</label>
                    </div>
                </div>

                <CodeHelpDialog v-model:search="searchCodeHelp" v-model:selection="selectedCodeHelp" v-model:visible="isCodeHelpDialog" @onComplete="codeHelpComplete" />
            </template>

            <template #end>
                
            </template>
        </Toolbar>
        <DataTable id="dt" ref="dt" :value="dataList" showGridlines
            :paginator="false" :rows="12" class="p-datatable-sm"
            rowGroupMode="subheader" groupRowsBy="corpNm" :loading="loading" scrollable scrollHeight="79vh"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[12,50, 100]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} rows" responsiveLayout="scroll"> 
            <Column header="No" style="min-width:3em; max-width:3em" exportFooter=" ">
                <template #body="{index}">
                    {{ index + 1 }}
                </template>
            </Column>
            <Column field="runYmd" header="운행월" :sortable="false" :style="{'display': 'inline-block', 'width': '95%'}" exportFooter=" ">
                <template #body="{ data, field }">
                    {{ formatToYM(data[field]) }}
                </template>
            </Column>
            <Column field="ctrPublicId" header="관할행정" :sortable="false" exportFooter=" ">
                <template #body="{data}">
                    {{(publicCodes.find(e=>e.code == data.ctrPublicId)||{codeNm:""})['codeNm']}}
                </template>
            </Column>
            <Column field="corpId" header="업체명" :sortable="false" exportFooter=" ">
                <template #body="{data}">
                    {{(corpCodes.find(e=>e.code == data.corpId)||{codeNm:""})['codeNm']}}
                </template>
            </Column>
            <Column field="areaTag" header="영역분류" :sortable="false" :footer="'총 합계'" :footerStyle="{'display': 'inline-block', 'width': '95%', 'text-align': 'right'}" exportFooter=" ">
                <template #body="{data}">
                    {{(cboAreaTags.find(e=>e.code == data.areaTag)||{codeNm:""})['codeNm']}}
                </template>
            </Column>
            <Column field="getCash" header="현금수익" :footer="computedTotle('getCash')" :sortable="false" :style="{'display': 'inline-block', 'width': '95%', 'text-align': 'right'}" exportFooter=" ">
                <template #body="{ data, field }">
                    {{ formatToPrice(data[field]) }}
                </template>
            </Column>
            <Column field="getTicket" header="승차권수익" :footer="computedTotle('getTicket')" :sortable="false" :style="{'display': 'inline-block', 'width': '95%', 'text-align': 'right'}" exportFooter=" ">
                <template #body="{ data, field }">
                    {{ formatToPrice(data[field]) }}
                </template>
            </Column>
            <Column field="getTcard" header="교통카드수익" :footer="computedTotle('getTcard')" :sortable="false" :style="{'display': 'inline-block', 'width': '95%', 'text-align': 'right'}" exportFooter=" ">
                <template #body="{ data, field }">
                    {{ formatToPrice(data[field]) }}
                </template>
            </Column>
            <Column field="getTrans" header="환승수익" :footer="computedTotle('getTrans')" :sortable="false" :style="{'display': 'inline-block', 'width': '95%', 'text-align': 'right'}" exportFooter=" ">
                <template #body="{ data, field }">
                    {{ formatToPrice(data[field]) }}
                </template>
            </Column>
            <Column field="getTot" header="합계수익" :footer="computedTotle('getTot')" :sortable="false" :style="{'display': 'inline-block', 'width': '95%', 'text-align': 'right'}" exportFooter=" ">
                <template #body="{ data, field }">
                    {{ formatToPrice(data[field]) }}
                </template>
            </Column>
            <template #groupheader="slotProps">
                <td style="font-weight: 600;">{{slotProps.data.corpNm}}</td>
            </template>
            <template #groupfooter="slotProps">
                <td style="min-width:3em; max-width:3em"></td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                    <div style="width: 100%; text-align: right; font-weight: 600;">업체 소계 ({{ computedSubTotle(slotProps.data.corpId) }}건)</div>
                </td>
                <td>
                    <div style="width: 100%; text-align: right; font-weight: 600;">{{ computedSubTotle(slotProps.data.corpId, 'getCash') }}</div>
                </td>
                <td>
                    <div style="width: 100%; text-align: right; font-weight: 600;">{{ computedSubTotle(slotProps.data.corpId, 'getTicket') }}</div>
                </td>
                <td>
                    <div style="width: 100%; text-align: right; font-weight: 600;">{{ computedSubTotle(slotProps.data.corpId, 'getTcard') }}</div>
                </td>
                <td>
                    <div style="width: 100%; text-align: right; font-weight: 600;">{{ computedSubTotle(slotProps.data.corpId, 'getTrans') }}</div>
                </td>
                <td>
                    <div style="width: 100%; text-align: right; font-weight: 600;">{{ computedSubTotle(slotProps.data.corpId, 'getTot') }}</div>
                </td>
            </template>
        </DataTable>
    </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import { useToast } from 'primevue/usetoast';
import CodeService from '@/service/cm/CodeService';
import CustService from '@/service/ma/CustService';
import MA301080Service from '@/service/ma/MA301080Service';
import JsUtils from '@/utilities/JsUtils';
import CodeHelpDialog from '@/components/CodeHelpDialog';


export default {
    components: {
        'CodeHelpDialog': CodeHelpDialog,
    },
    setup() { 
        onMounted( async () => {
            searchParams.compSeq = 1;
            // 검색조건에 시작일자,종료일자를 표시한다
            let date = new Date();  
            let calcFrYmd = new Date(date.getFullYear(), date.getMonth(), 1);  // 당월 첫째 일자
            searchParams.calcFrYmd = JsUtils.getDateString(calcFrYmd);            
            searchParams.calcToYmd = JsUtils.getDateString(new Date());          // 현재 일자
            searchParams.gubun = '0';

			codeService.getCodeList({ compSeq:1, upCode:'_public_id'}).then(data=> publicCodes.value = data);  // 관할행정지역 코드
			codeService.getCodeList({ compSeq:1, upCode:'_useoil_tag'}).then(data=> useOilTagCodes.value = data);  // 사용자권한 코드
            codeService.getCodeList({ compSeq:1, upCode:'_area_tag'}).then(data=> cboAreaTags.value = data);  // 영역분류 코드
            custService.getCodeList({compSeq:1}).then(data => corpCodes.value = data); // 업체코드 전부 가지고오기

            // 로그인한 사용자 정보를 얻어온다
            var user = JSON.parse(localStorage.getItem("user"));
            if(user != null && user.username != null) {
                searchParams.compSeq = user.compSeq;    // 법인코드
                searchParams.userGbCd = user.userGbCd; // 사용자구분코드

                if(user.publicId != null && user.publicId != '' && (user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr')) {
                        //alert(JSON.stringify(user.publicId));
                        // 업체 목록을 얻어온다
                        await custService.getCodeList(searchParams).then(data => {
                            custCodes.value = data;
                            // 업체 목록에서 사용자가 속한 업체를 선택된 상태로 만든다
                            searchParams.corpId = user.custSeq;
                            if(user.userGbCd != null) {
                                // 업체사용자 또는 업체관리자인 경우, 자신이 속한 업체만 볼수 있게 한다
                                if(user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr') {
                                    isCustUser.value = true;  
                                    let ctrPublicIdList = [];

                                    publicCodes.value.forEach(element => {
                                        console.log("row.code = " + element.code)
                                        if(user.ctrPublicIds != null && user.ctrPublicIds.includes(element.code)){
                                            ctrPublicIdList.push({code:element.code, codeNm:element.codeNm});
                                        }
                                    });

                                    //alert("ctrPublicIdList.length = "+ ctrPublicIdList.length);
                                    if(ctrPublicIdList.length > 0) {
                                        publicCodes.value = ctrPublicIdList;
                                        disabledCtrPublicId.value = false;
                                    }
                                    else {
                                        //publicCodes.value = {code:user.publicId, codeNm:user.publicNm};
                                        searchParams.ctrPublicId = user.publicId;
                                        disabledCtrPublicId.value = true;
                                    }
                                }
                                // 시군구담당자인 경우
                                if(user.userGbCd == 'ct_mngr') {
                                    searchParams.ctrPublicId = user.publicId;  // 업체소재지
                                }
                            }                                    
                        });
                }
            }

        })
        const isCustUser = ref(false);
		const codeService = new CodeService();
        const custService = new CustService();
        const ma301080Service = new MA301080Service();
        const searchParams = reactive({ctrPublicId: null, corpId: null, areaTag: null, gubun: null, carId: null, calcFrYmd: null, calcToYmd: null, calcYm: null, calcCnt: null});
        const toast = useToast();
        const loading = ref(false);
        const dataList = ref([]);
        const publicCodes = ref([]);
        const custCodes = ref([]);
        const corpCodes = ref([]);
        const useOilTagCodes = ref([]);
        const cboAreaTags = ref([]);
        const cboRunTags = ref([]);
        const cboCarNos = ref([]);
        const cboGubun = ref([{code: '0', codeNm: '업체'}, {code: '1', codeNm: '실사'}]);

        // 관할행정 선택여부
        const disabledCtrPublicId = ref(false);

        // 코드도움 Dialog
        const isCodeHelpDialog = ref(false);    // 코드도움다이얼로그 표시 여부
        const searchCodeHelp = reactive({helpId:"_calc_cnt", compSeq:1, conds:[{'calcYm':null}]});  // 코드도움 검색조건, 평가차수인 경우 코드도움ID "_calc_cnt", 검색조건 conds:[{'calcYm':null}]에서 calcYm는 평가년도 임 
        const selectedCodeHelp = ref({});       // 코드도움 다이얼로그 검색결과에서 선택된 항목

        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "SEARCH":
                        search();
                    break;
                default:
            }
        }

        const btnDialog = (_act, _str) => {
            switch(_act) {
                case 'CodeHelpDialog':
                    searchCodeHelp.conds[0] = _str;  
                    //searchCodeHelp.calcYm = _str;
                    isCodeHelpDialog.value = true;
                    break;
                default:
                    break;
            }
        }

        const search = () => {
            searchParams.calcFrYmd = JsUtils.convertDateToString(searchParams.calcFrYmd);
            searchParams.calcToYmd = JsUtils.convertDateToString(searchParams.calcToYmd);
            
            // 검색조건에서 필수 입력값을 체크한다 - 검색데이터량이 많은 경우(예: 3천건 이상) 필수로 적용할 것!!!    
            if(!JsUtils.checkUndefineColumns(searchParams, ["calcYm", "calcCnt"])){
                toast.add({severity:'warn', summary:'필수입력 확인', detail:'평가년도, 평가차수를 선택해주세요.', life:2000});
                return;
            }

            loading.value = true;
            ma301080Service.getList(searchParams).then(data => {
                if (data.length == 0) toast.add({severity:'warn', summary:'조회 결과', detail:'조회 결과가 없습니다.', life:2000});
                    dataList.value = data;
            }).finally(() => {
                loading.value = false;
            });
        };

        const changePublicId= () => {
            // 현재 선택된 업체소재지로 업체 목록을 가져와서 업체명 Dropdown 목록에 표시한다
            if(isCustUser.value) {
                return;
            }
            if(searchParams.ctrPublicId != null) {
                custService.getCodeList(searchParams).then(data => {
                    custCodes.value = data;
                });
            }
            else {
                custCodes.value = [];
            }
            searchParams.corpId = null;
        }

        const changeCustSeq = () => {
            cboCarNos.value = [];
            // 현재 선택된 업체에 속한 차량번호 목록을 다시 조회하여 Dropdown 목록에 표시한다
            codeService.getTableCodeList({ sqlId:'car_code', compSeq:1, corpId: searchParams.corpId}).then(data=> {
                cboCarNos.value = data;
            });
        }

        // 코드헬프 후처리. 조회조건 영역에 데이터 바인딩
        const codeHelpComplete = () => {
            Object.keys(searchParams).map((setVal) => {
                Object.keys(selectedCodeHelp.value).map((getVal) => {
                    let tempSetVal = setVal == setVal.toUpperCase() ? formatToCameCase(setVal) : setVal;
                    let tempGetVal = getVal == getVal.toUpperCase() ? formatToCameCase(getVal) : getVal;
                    if (tempSetVal == tempGetVal) {
                        searchParams[setVal] = selectedCodeHelp.value[getVal]
                    }
                })
            })
        }

        // 총 합계 계산
        const computedTotle = (fieldNm = '') => {
            if (fieldNm === '') return 0;

            let total = 0;
            for (let dataRow of dataList.value) {
                total += typeof dataRow[fieldNm] === 'string' ? parseFloat(dataRow[fieldNm]) : dataRow[fieldNm];
            }

            return formatToPrice(total);
        }

        const computedSubTotle = (name = '', fieldNm = '') => {
            let total = 0;
            if (dataList.value) {
                for (let data of dataList.value) {
                    if (data.corpId === name) {
                        if (fieldNm === '') total++;
                        else total += data[fieldNm];
                    }
                }
            }

            return formatToPrice(total);
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, users.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(users.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

          // 천단위마다 콤마(,) 표시를 한다
        const formatToPrice = (value) => {
           var num = Number(value).toFixed(0);
          return `${Number(num).toLocaleString()}`; // "ko-KR"
        }

        // 날짜 포맷 수정
        const formatToYM = (value = '') => {
            return `${value.replace(/(\d{4})(\d{2})/, '$1-$2')}`
        }

        // '_'언더바로 연결되어있는 대문자 카멜케이스로 변경 ('STR_TEST_TEXT' => strTestText)
        const formatToCameCase = (str = '') => {
            return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
        }

        return { 
            dt, searchParams, dataList, publicCodes, useOilTagCodes, cboAreaTags, cboRunTags, cboCarNos, custCodes, corpCodes, cboGubun, loading, isCustUser,
            formatToPrice, btnAct, downloadExcel, exportCSV, changePublicId, changeCustSeq, formatToYM, formatToCameCase, disabledCtrPublicId,
            isCodeHelpDialog, searchCodeHelp, selectedCodeHelp, codeHelpComplete, btnDialog, computedTotle, computedSubTotle
        }

    }
}
</script>

<style lang="scss" scoped>
.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.user-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .user-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
